import { resolveActiveSchedule } from '@ghostscreen/scheduling';
/**
 * Offline daypart resolution from the last sync schedule snapshot (ADR 0005).
 */
export function resolveDesiredPlaylist(snapshot, now = new Date()) {
    const rules = snapshot.windows.map((window) => ({
        id: window.id,
        playlistId: window.playlistId,
        startLocalTime: window.startLocalTime,
        endLocalTime: window.endLocalTime,
        daysOfWeek: window.daysOfWeek,
        priority: window.priority,
        targetSpecificity: window.targetSpecificity,
        updatedAt: window.updatedAt,
    }));
    const resolved = resolveActiveSchedule({
        rules,
        now,
        timeZone: snapshot.timeZone,
    });
    if (resolved.status === 'override') {
        const window = snapshot.windows.find((entry) => entry.id === resolved.rule.id);
        if (window) {
            return {
                playlistId: window.playlistId,
                playlistVersion: window.playlistVersion,
            };
        }
    }
    return {
        playlistId: snapshot.defaultPlaylistId,
        playlistVersion: snapshot.defaultPlaylistVersion,
    };
}
//# sourceMappingURL=resolve-desired.js.map